<template>
  <section class="jd jd-company">
    <div class="jd-section jd-section--company">
      <h2>{{ $t('jobDetail.companyAbout') }}</h2>
      <p class="jd__company-about">{{ companyAbout }}</p>
    </div>
  </section>
</template>

<script>
import CompanyMixin from '../../../mixins/company'

export default {
  mixins: [CompanyMixin],
}
</script>

<style lang="postcss" scoped>
.jd__company-about {
  @apply mt-3 whitespace-pre-wrap break-words;
}

@screen desktop {
  >>> p,
  >>> span {
    @apply text-17/4;
  }
  .jd-section.jd-section--company {
    @apply pt-7;
  }
  .jd-section.jd-section--company h2 {
    @apply mb-4;
  }
}
</style>
